/**
 * Created by Roman T on 9/5/2017.
 * Modified by Kim Janneck on 2017-11-15 for issue 882.
 */
var DetailPaymentDetailController = (function () {
    function DetailPaymentDetailController(topic, $scope, socket, env) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.env = env;
        this.comp = 'invoice_flags'; // Name of this component
        this.visibleDetail = false; // Close section
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic has been updated from the server...check if this component is part of 
            // what was changed
            if (data.indexOf(_this.comp) > -1) {
                // If so, set edit status accordingly...
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    DetailPaymentDetailController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp); // Set edit based on value in topic.editableComponents
    };
    /**
     * Default function for all components that use the 10k edit/save/cancel component
     * @param action
     */
    DetailPaymentDetailController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // Set the status of this component to Updating...
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                // Prepare data to be saved
                var updateObject = {
                    data: {
                        invoice_flags: {
                            add: true,
                            data: this.topic.temp.invoice_flags
                        }
                    },
                    editOption: undefined,
                    id: this.topic.topic._id,
                    type: ['invoice_flags']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
                this.edit.editMode = this.topic.cancelEdit(this.comp); // Turn edit off
            }
        }
        else if (action === 'edit') {
            // Set temp values in topic for invoice_flags - and set edit mode to editable
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
            this.setDateFields();
            this.edit.editMode = true;
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp); // Set status uneditable
        }
    };
    /**
     * Function (alas) to convert the three date fields to Date objects for use with the md-datepicker
     */
    DetailPaymentDetailController.prototype.setDateFields = function () {
        var _this = this;
        var dates = ['requestedTimestamp', 'receivedTimestamp', 'invEFTDate', 'submittedTimestamp', 'paidDate'];
        angular.forEach(dates, function (dateField) {
            if (_this.topic.topic.invoice_flags[dateField]) {
                if (!_this.topic.temp.invoice_flags) {
                    _this.topic.temp.invoice_flags = {};
                }
                _this.topic.temp.invoice_flags[dateField] = new Date(_this.topic.topic.invoice_flags[dateField]);
            }
        });
    };
    /**
     * Function to toggle whether the section is open or closed
     */
    DetailPaymentDetailController.prototype.toggleDetail = function () {
        this.visibleDetail = !this.visibleDetail;
    };
    DetailPaymentDetailController.$inject = ['topic', '$scope', 'socket', 'env'];
    return DetailPaymentDetailController;
}());
var DetailPaymentDetailComponent = (function () {
    function DetailPaymentDetailComponent() {
        this.templateUrl = 'detail-payment-detail.html';
        this.controllerAs = 'vm';
        this.controller = DetailPaymentDetailController;
    }
    return DetailPaymentDetailComponent;
}());
angular
    .module('application')
    .component('detailPaymentDetail', new DetailPaymentDetailComponent());

//# sourceMappingURL=detail.payment.detail.component.js.map
